export const buildOptionsMaps = options => {
  const optionsById = new Map()
  const optionsByUserId = new Map()

  options.forEach(option => {
    optionsById.set(option.id, option)
    if (option.idUser && !optionsByUserId.has(option.idUser)) {
      optionsByUserId.set(option.idUser, option)
    }
  })

  return { optionsById, optionsByUserId }
}
